import { Box, Divider, Paper, Typography } from '@mui/material';
import React from 'react';
import { Colors } from '../../../assets/theme/Colors';

const MarkerIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="10" fill={color} stroke="#fff" strokeWidth="2" />
    <circle cx="16" cy="16" r="6" fill="#fff" />
  </svg>
);

const Legend = () => (
  <Box sx={{ position: 'absolute', top: 10, left: 10 }}>
    <Paper sx={{ py: '8px', pl: '10px', pr: '16px', borderRadius: 2 }}>
      <Typography variant="body2" sx={{ color: 'text.disabled', fontWeight: 700, ml: '6px' }}>
        MAP PINS
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <MarkerIcon color={Colors.primaryColor} />
        <Typography variant="subtitle2">Donor (pickup)</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <MarkerIcon color={Colors.appBar.main} />
        <Typography variant="subtitle2">Agency (drop-off)</Typography>
      </Box>
      <Divider sx={{ ml: '6px' }} />
      <Typography variant="caption" sx={{ color: 'text.disabled', ml: '6px' }}>
        Click a pin to add it as a stop
      </Typography>
    </Paper>
  </Box>
);

export default Legend;
